<template>
  <div class="custom-modal ticket-modal" :class="{ 'is-open': showTicketModal}">
    <nav class="navbar">
      <div class="navbar-start">
        <!-- <button  style="border: 0; padding: 0; background-color: white"> -->
        <span
          class="icon is-large"
          @click="$store.dispatch('ui/toggleModal', { name: 'TICKET_MODAL', state: false })"
        >
          <i class="mdi mdi-close mdi-24px"></i>
        </span>
        <!-- </button> -->
      </div>
    </nav>

    <!-- CHECK EVENT INFO -->
    <div class="p-1 is-size-6 modal-body" :class="{ 'is-open': showTicketModal}">
      <p class="subtitle is-4 has-text-weight-semibold mb-1">{{ $t('ui.ticketInfo') }}</p>

      <p class="is-size-6 mb-xsm has-text-grey has-text-weight-light">{{ $t('ui.eventName') }}</p>
      <h3 class="is-size-6 has-text-weight-medium">{{ userBasket.eventInfo.eventName }}</h3>

      <!-- datetimt -->
      <div class="media-content mt-1">
        <p class="is-size-6 mb-xsm has-text-grey has-text-weight-light">{{ $t('ui.eventDate') }}</p>
        <div class="content">
          <time
            class="is-block has-text-weight-medium"
            :datetime="userBasket.eventInfo.eventDateTime.startTime | toHTMLDate"
          >
            {{ userBasket.eventInfo.eventDateTime.startTime.getDate() }}
            {{ $t(`monthNames.${userBasket.eventInfo.eventDateTime.startTime.getMonth()}`) }},
            {{ $t(`dayNames.${userBasket.eventInfo.eventDateTime.startTime.getDay()}`) }}
          </time>
          <time
            class="is-inline-block"
            :datetime="userBasket.eventInfo.eventDateTime.startTime | toHTMLDateTime"
          >{{ userBasket.eventInfo.eventDateTime.startTime | toTime }}</time> -
          <time
            class="is-inline-block"
            :datetime="userBasket.eventInfo.eventDateTime.endTime | toHTMLDateTime"
          >{{ userBasket.eventInfo.eventDateTime.endTime | toTime }}</time>
        </div>
      </div>

      <!-- Venue -->
      <p
        class="is-size-6 mb-xsm has-text-grey has-text-weight-light mt-1"
      >{{ $t('ui.eventLocation') }}</p>
      <p class="has-text-weight-medium">{{userBasket.eventInfo.eventVenueName}}</p>
      <p>{{ userBasket.eventInfo.eventVenueAddress}}</p>

      <div class="mt-1">
        <!-- selected  tickets table-->
        <p
          class="is-size-6 mb-xsm has-text-grey has-text-weight-light"
        >{{ $t('ui.selectedTickets') }}</p>
        <div v-if="userBasket" class="mt-half">
          <div v-for="item in userBasket.tickets" :key="item.id">
            <div class="level is-mobile mb-0" v-if="item.numberOfTickets">
              <div class="level-left">
                <div class="level-item">
                  <span>
                    {{ item.ticketPrice }} ₺
                    <span class="has-text-weight-light">x</span>
                    {{ item.numberOfTickets }} {{ $t(`ticket.${item.ticketType}`) }}
                  </span>
                  <b-tooltip
                    v-if="item.ticketType === 'student'"
                    multilined
                    class="ml-half"
                    type="is-white"
                    :label="$t('ui.studentTicketTooltip')"
                  >
                    <b-tag
                      class="is-rounded is-size-6 is-small has-border is-white has-text-grey-dark"
                    >?</b-tag>
                  </b-tooltip>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">{{ item.numberOfTickets * item.ticketPrice }} ₺</div>
              </div>
            </div>
            <!-- hr -->
            <hr class="is-narrow" v-if="item.numberOfTickets >= 1 " />
          </div>
        </div>

        <!-- service fee -->
        <div class="level is-mobile mb-0" v-if="basketTotal.totalPrice > 3">
          <div class="level-left">
            <div class="level-item">
              <span class>{{ $t('ticket.serviceFee') }}</span>
              <b-tooltip
                multilined
                class="ml-half"
                type="is-white"
                :label="$t('ui.serviceFeeExplanation')"
              >
                <b-tag
                  class="is-rounded is-size-6 is-small has-border is-white has-text-grey-dark"
                >?</b-tag>
              </b-tooltip>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">{{ basketTotal.serviceFee }} ₺</div>
          </div>
        </div>
        <hr class="is-narrow" v-if="basketTotal.totalPrice > 0" />

        <!-- total -->
        <div class="level is-mobile mb-0" v-if="basketTotal.totalPrice > 0">
          <div class="level-left">
            <div class="level-item">
              <span class="has-text-weight-bold">{{ $t('ui.total') }}</span>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item has-text-weight-bold">{{ basketTotal.totalPrice }} ₺</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { toggleModals } from "@/mixins/modal";

export default {
  mixins: [toggleModals],
  computed: {
    ...mapGetters({
      showTicketModal: "ui/showTicketModal",
      userBasket: "user/userBasket",
      basketTotal: "user/basketTotal"
    })
  },
  mounted() {
    console.log('mounted ticket', this.userBasket);
  }
};
</script>

<style>
</style>